import { useEffect, useRef } from "react";

/**
 * Simple hook to return if a component is mounted.
 */

export const useIsMounted = (onMount?: (isMounted: boolean) => void): boolean => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      onMount?.(isMounted.current);
    }
  }, []);

  return isMounted.current;
};
